import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { PropertyProvider } from "@/context/PropertyContext";
import { BillingProvider } from "@/context/BillingContext";
import { Toaster } from "sonner";

import AppRoutes from "@/AppRoutes";
import CookieBanner from "@/components/CookieBanner";
import PWAInstallPrompt from "@/components/PWAInstallPrompt";

export default function App() {
  return (
    <AuthProvider>
      <BillingProvider>
        <PropertyProvider>
          <BrowserRouter>
            <Toaster richColors position="top-right" />
            <AppRoutes />
            <CookieBanner />
            <PWAInstallPrompt />
          </BrowserRouter>
        </PropertyProvider>
      </BillingProvider>
    </AuthProvider>
  );
}
